import styles from "./styles.module.css";
import {Button } from "..";
import i18n from "../../producers/i18n";

export const Navigation = ({
  onNext,
  onBack,
  isNextActive,
  isBackActive,
  isBackMissing = false,
  isBackInactive,
  isNextInactive,
}) => {
  return (
    <div className={styles.navigation}>
      <div>
        {!isBackMissing && (
          <Button 
            onClick={onBack}
            active={isBackActive}
            inactive={isBackInactive}
            type={"secondary"}
          >
            {i18n.t("global.back")}
           
          </Button>
        )}
      </div>
      <Button
        active={isNextActive}
        onClick={onNext}
        inactive={isNextInactive}
      >
        {i18n.t("global.next")}
      </Button>
    </div>
  );
};
